import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get, post } from 'api/requests';

import { IParamsReq } from 'types';
import { AppThunk } from 'store/types';
import { IPlacementsStatus, PlacementParam } from 'features/PlacementsStatus/types';

interface IPlacementsStatusStore {
  loading: boolean;
  placementsData: IPlacementsStatus;
}

const initialState: IPlacementsStatusStore = {
  placementsData: {} as IPlacementsStatus,
  loading: false,
};

const reset: CaseReducer<IPlacementsStatusStore> = () => initialState;

const placementsStatus: CaseReducer<IPlacementsStatusStore, PayloadAction<IPlacementsStatus>> = (
  state,
  action,
) => {
  state.placementsData = action.payload;
};

const loading: CaseReducer<IPlacementsStatusStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

export const placementsStatusSlice = createSlice({
  name: 'placementsStatus',
  initialState,
  reducers: {
    loading: loading,
    placementsStatus,
    reset,
  },
});

const {
  loading: setLoading,
  placementsStatus: setPlacementsStatus,
  reset: setPlacementsReset,
} = placementsStatusSlice.actions;

export const getPlacementsStatus = (search: IParamsReq): AppThunk => {
  return dispatch => {
    dispatch(setLoading(true));

    get<IPlacementsStatus>(`/api/standards/izs/queue/${Number(search.queue)}/placements/`, search)
      .then(({ data }) => {
        dispatch(setPlacementsStatus(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };
};

export const izsAppointmentsCall =
  (data: PostDataIzsAppointments, search: IParamsReq): AppThunk =>
  dispatch => {
    post('/api/timesheet/izs-appointments/', { ...data }).then(() => {
      dispatch(getPlacementsStatus(search));
    });
  };

export { setLoading, setPlacementsReset };

interface PostDataIzsAppointments {
  date: string;
  selectedPlacements: PlacementParam[];
}
